<div class="min-h-[calc(100vh-4rem)] relative">
  <div class="px-6 py-4 font-medium relative min-h-[calc(100vh-4rem)]">
    <div class="flex items-center justify-between mb-2">
      <a class="text-amazone-orange hover:text-amazone-orange-hover ms-2" [routerLink]="['/sw-part-number/overview']">
        ← Back to overview
      </a>
      <p class="text-amazone-green ms-2">
        Deactivated SW Part Numbers <strong>{{ itemsTotalCount }}</strong>
      </p>
    </div>
    <app-sw-part-number-recycling-table
      [recycledSwPartNumbers]="items"
      (scrolledToBottom)="onScrolledToBottom()"
      (sortByFieldChanged)="onSortByFieldChanged($event)"
    ></app-sw-part-number-recycling-table>
  </div>
</div>
